import React, { useEffect, useState, useRef, forwardRef } from 'react';
import { useMutation } from '@tanstack/react-query';
import CircularProgress from '@mui/material/CircularProgress';
import { useUser } from '../../context/UserContext';
import { LoginFastEapp } from '../../api/fast';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';

import RenderIcon from '../../pages/Software/Subpages/SoftwareList/RenderIcon';

import Button from '@mui/material/Button';

import DialogContentText from '@mui/material/DialogContentText';

function FASTLink({ children, closePopover, onMouseEnter, onMouseLeave, ...props }, ref) {
  const user = useUser();
  const [fastData, setFastData] = useState(null);
  const [open, setOpen] = useState(false);

  const openFASTURL = () => {
    //if (agreed) {
    //    FASTURL.refetch()
    //}
    //else {
    setOpen(true);
    //}

    // Close popover after a short delay (let modal render first)
  };

  //useEffect(() => {
  //    if (!firstRender.current) {
  //        openFASTURL()
  //    } else {
  //        firstRender.current = false;
  //    }
  //}, [agreed])

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return; // Block closing
    }
    setOpen(false);
    FASTURL.mutate();
  };

  const handleConfirm = (e, r) => {
    handleClose(e, r);
  };

  function checkLOB(iD3Code) {
    var isValid = user.LOB.find((o) => o.ProductCode == iD3Code);
    return isValid != null && isValid != undefined;
  }

  const FASTURL = useMutation({
    mutationFn: async () => await LoginFastEapp()(),
    gcTime: 0, // Renamed from cacheTime in v5
  });

  // Handle success with useEffect
  useEffect(() => {
    if (FASTURL.isSuccess && FASTURL.data) {
      setFastData(FASTURL.data);
    }
  }, [FASTURL.isSuccess, FASTURL.data]);

  const [errorTimer, setErrorTimer] = useState(false);

  useEffect(() => {
    if (fastData?.postBackUrl) {
      document.forms['frmFAST' + props.id].submit();

      // if (closePopover) {
      //closePopover();
      // }
    }
  }, [fastData]);

  useEffect(() => {
    if (FASTURL.isError) {
      setTimeout(() => {
        setErrorTimer(true);
      }, 3000);
    }
  }, [FASTURL.isError]);

  if (FASTURL.isError && !FASTURL.isPending) {
    if (errorTimer) {
      return (
        <li ref={ref} style={{ listStyle: 'none' }}>
          <a
            onClick={() => {
              openFASTURL();
            }}
          >
            Click to retry
          </a>
        </li>
      );
    }
    return (
      <li ref={ref} style={{ listStyle: 'none' }}>
        <a>Could not generate FAST Link</a>
      </li>
    );
  }

  return (
    <>
      <div
        ref={ref}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start', // Changed from 'center' to 'flex-start'
          height: '100%',
          width: '100%',
          paddingTop: '8px', // Add some top padding to match ButtonBase
        }}
      >
        {!props.customStyle ? (
          <a
            className={`d-flex ${!props.isBetween ? '' : 'justify-content-between'} align-items-center`}
            onClick={() => {
              openFASTURL();
            }}
          >
            {props.isShownICon && (
              <RenderIcon>
                <LaunchOutlinedIcon />
              </RenderIcon>
            )}
            {props.name ? props.name : 'iProvide INSpeed Plus eApp'}
            {children}
            {FASTURL.isPending && <CircularProgress size={16} />}
          </a>
        ) : (
          <a
            onClick={() => {
              openFASTURL();
            }}
            style={{
              display: 'contents',
              textDecoration: 'none',
              color: 'inherit',
            }}
          >
            {children}
            {FASTURL.isFetching && <Spinner animation="border" size="sm" />}
          </a>
        )}
        {fastData && (
          <form
            action={fastData?.postBackUrl}
            id={'frmFAST' + props.id}
            target="_blank"
            method="POST"
          >
            <input
              type="hidden"
              id="SAMLResponse"
              name="SAMLResponse"
              value={fastData?.samlResponse ?? ''}
            />
            <input
              type="hidden"
              id="RelayState"
              name="RelayState"
              value={fastData?.relayUrl ?? ''}
            />
          </form>
        )}
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="pdf-dialog-title"
        aria-describedby="pdf-dialog-description"
        container={document.body} // Explicitly set portal target
        disablePortal={false} // Ensure portal is enabled (default)
        maxWidth={false}
        sx={{
          zIndex: 1500,
          '& .MuiDialog-container': {
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex', // Ensure flex display
            width: 'inherit',
          },
          '& .MuiDialog-paper': {
            width: '70vw',
            height: '70vh',
            maxWidth: '70vw',
            maxHeight: '70vh',
            margin: 'auto', // Change from 0 to auto
            position: 'relative', // Ensure proper positioning
          },
        }}
        className="pdf-modal"
        disableEscapeKeyDown // Disable ESC key
      >
        <DialogTitle id="pdf-dialog-title">{'Acknowledge PDF to Continue Logging In'}</DialogTitle>
        <DialogContent>
          <h4>An Agent is not permitted to sign for the insured or owner, even if</h4>
          <ul>
            <li>
              they have prior or real time verbal or written authorization from the client; and/or
            </li>
            <li>they are on a screen sharing call with the client at the time of application</li>
          </ul>
          <object
            data="/images/eAppSignatureMethodOption1.pdf"
            type="application/pdf"
            width="100%"
            height="550px"
          >
            <p>
              Unable to display PDF file.{' '}
              <a href="/images/9104ElectronicSignature Rules.pdf">Download</a> instead.
            </p>
          </object>
        </DialogContent>
        <DialogActions>
          <Button
            style={{ color: 'white', backgroundColor: 'red' }}
            variant="contained"
            color="error"
            onClick={handleConfirm}
          >
            Acknowledge
          </Button>
        </DialogActions>
      </Dialog>

      {/* <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="pdf-modal-title"
                aria-describedby="pdf-modal-description"
                id="pdf-modal"
                container={document.body} // Explicitly set portal target
                disablePortal={false} // Ensure portal is enabled (default)
                sx={{ zIndex: 1400 }}
            >
                <div>
                    <div id="pdf-modal-title" variant="h6" component="h2">
                        Acknowledge PDF to Continue Logging In
                    </div>
                    <h4 id="pdf-modal-description">An Agent is not permitted to sign for the insured or owner, even if</h4>
                    <ul>
                        <li>they have prior or real time verbal or written authorization from the client; and/or</li>
                        <li>they are on a screen sharing call with the client at the time of application</li>
                    </ul>
                    <object data="/images/eAppSignatureMethodOption1.pdf" type="application/pdf" width="100%" height="550px">
                        <p>Unable to display PDF file. <a href="/images/9104ElectronicSignature Rules.pdf">Download</a> instead.</p>
                    </object>
                    <Button className="btn btn-danger" type="button" onClick={handleClose}>Acknowledge</Button>
                </div>
            </Modal>*/}
    </>
  );
}

export default forwardRef(FASTLink);
